import React                                from 'react';

import { SpinnerContainer, SpinnerOverlay } from 'components/Spinner/spinner.styles';

const Spinner = () => (
	<SpinnerOverlay>
		<SpinnerContainer />
	</SpinnerOverlay>
);

export default Spinner;
